/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for content of new day model
 * @export
 * @interface AppointmentTypeTimeslotsRequest
 */
export interface AppointmentTypeTimeslotsRequest {
    /**
     * Unique identifier of the appointmentType
     * @type {string}
     * @memberof AppointmentTypeTimeslotsRequest
     */
    appointmentTypeId?: string;
    /**
     * start time of slot
     * @type {string}
     * @memberof AppointmentTypeTimeslotsRequest
     */
    start?: string;
    /**
     * end time of slot
     * @type {string}
     * @memberof AppointmentTypeTimeslotsRequest
     */
    end?: string;
}

/**
 * Check if a given object implements the AppointmentTypeTimeslotsRequest interface.
 */
export function instanceOfAppointmentTypeTimeslotsRequest(value: object): value is AppointmentTypeTimeslotsRequest {
    return true;
}

export function AppointmentTypeTimeslotsRequestFromJSON(json: any): AppointmentTypeTimeslotsRequest {
    return AppointmentTypeTimeslotsRequestFromJSONTyped(json, false);
}

export function AppointmentTypeTimeslotsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentTypeTimeslotsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentTypeId': json['appointmentTypeId'] == null ? undefined : json['appointmentTypeId'],
        'start': json['start'] == null ? undefined : json['start'],
        'end': json['end'] == null ? undefined : json['end'],
    };
}

export function AppointmentTypeTimeslotsRequestToJSON(json: any): AppointmentTypeTimeslotsRequest {
    return AppointmentTypeTimeslotsRequestToJSONTyped(json, false);
}

export function AppointmentTypeTimeslotsRequestToJSONTyped(value?: AppointmentTypeTimeslotsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentTypeId': value['appointmentTypeId'],
        'start': value['start'],
        'end': value['end'],
    };
}

